import React from "react";

export default function Header() {
  return (
    <header className="header-container">
      <img src="/assets/logo.png" />
    </header>
  );
}
